// # #############################################
// # Title : Policy Levers
// # Authors : Sameer, Dhruv, Shubham, Mahesh, Atul
// # Last Modified : Dhruv, October 2019 // Addded Manufacturing cost under product pricing near submit button.  Line 1486
// # Version : 19.10.03
// # Description : This is the code for the policy lever pannel on the run scenario view
// # ############################################

// Import required Libraries

import React, { Component } from "react";
import "../css/Pricing.css";
import '../css/PromotionWidget.css';
import config from "../utils/config";
import GlobalEvents from "../utils/global-events";
import SpiderChart from "./SpiderChart";
import HorizontalBarChart from "./HorizontalBarChart";
import Checkbox from './Checkbox';
import { abbreviateNumber } from "../utils/helperFunction";
import Slider from 'rc-slider';
import Grid from '@material-ui/core/Grid';

let chartColor = ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"];

function convertRange(value, r1, r2) {
    // Function to convert taste ,pleasure and health to stars
    return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
}

function swapJsonKeyValues(input) { // Function to make JSON keys as values and values as keys
    var one, output = {};
    for (one in input) {
        if (input.hasOwnProperty(one)) {
            output[input[one]] = one;
        }
    }
    return output;
}

const category = {
    tv: {
        slots: [
            'Morning',
            'Midday',
            'Matinee',
            'Evening',
            'Night'
        ],
        days: [
            'Weekday',
            'Weekend'
        ],
        frequency: {
            '1x': 1,
            '2x': 2,
            '3x': 3,
            '4x': 4,
            '5x': 5
        }
    },
    radio: {
        slots: [
            'Morning',
            'Midday',
            'Matinee',
            'Evening',
            'Night'
        ],
        days: [
            'Weekday',
            'Weekend'
        ],
        frequency: {
            '1x': 1,
            '2x': 2,
            '3x': 3,
            '4x': 4,
            '5x': 5
        }
    },
    billboard: {
        slots: [],
        days: [],
        frequency: {
            '1x: Billboard bicycle': 1,
            '2x: Transit advertising (buses, taxis)': 2,
            '3x: Commuter displays(lamp post, bus stops)': 3,
            '4x: Print and digital': 4,
            '5x: All of the above': 5
        }
    },
    print: {
        days: [
            'Weekday',
            'Weekend'
        ],
        slots: [],
        frequency: {
            '1x: Classified ads section for newspapers': 1,
            '2x: Right column for newspapers': 2,
            '3x: Special sections popular magazines & newspapers': 3,
            '4x: Half page ad popular magazines & newspapers': 4,
            '5x: Cover Page All magazines & newspapers': 5
        }
    },
    digital: {
        slots: [
            'Native advertising - In-game, In-web series',
            'Search Engine Optimized Marketing (SEO)',
            'Display Marketing - Blogs, feeds or useful websites',
            'Social Media Marketing',
            'Email, Text - Direct Messaging'
        ],
        days: [],
        frequency: {}
    }
}

const prices = [{
    "Media": "digital",
    "Base_Price": 11000000,
    "Morning": 0,
    "Midday": 0,
    "Matinee": 0,
    "Evening": 0,
    "Night": 0,
    'Native advertising - In-game, In-web series': 750000,
    'Search Engine Optimized Marketing (SEO)': 1000000,
    'Display Marketing - Blogs, feeds or useful websites': 2000000,
    'Social Media Marketing': 5000000,
    'Email, Text - Direct Messaging': 9000000,
    "Weekday": 0,
    "Weekend": 0,
    "X1": 750000,
    "X2": 1000000,
    "X3": 2000000,
    "X4": 5000000,
    "X5": 9000000
},
{
    "Media": "print",
    "Base_Price": 35000000,
    "Morning": 0,
    "Midday": 0,
    "Matinee": 0,
    "Evening": 0,
    "Night": 0,
    "Weekday": 3000000,
    "Weekend": 5000000,
    "X1": 1000000,
    "X2": 2000000,
    "X3": 5000000,
    "X4": 8000000,
    "X5": 12000000
},
{
    "Media": "tv",
    "Base_Price": 37000000,
    "Morning": 6000000,
    "Midday": 3500000,
    "Matinee": 2000000,
    "Evening": 3500000,
    "Night": 2000000,
    "Weekday": 3000000,
    "Weekend": 4000000,
    "X1": 2500000,
    "X2": 3500000,
    "X3": 6000000,
    "X4": 9000000,
    "X5": 12000000
},
{
    "Media": "billboard",
    "Base_Price": 22000000,
    "Morning": 0,
    "Midday": 0,
    "Matinee": 0,
    "Evening": 0,
    "Night": 0,
    "Weekday": 0,
    "Weekend": 0,
    "X1": 1500000,
    "X2": 2500000,
    "X3": 4000000,
    "X4": 8000000,
    "X5": 12000000
},
{
    "Media": "radio",
    "Base_Price": 15000000,
    "Morning": 1250000,
    "Midday": 2000000,
    "Matinee": 1500000,
    "Evening": 2000000,
    "Night": 750000,
    "Weekday": 1200000,
    "Weekend": 1800000,
    "X1": 750000,
    "X2": 1750000,
    "X3": 2500000,
    "X4": 5000000,
    "X5": 10000000
}
];

class PolicyLever extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // default state
            simCompleted: false,
            hide: false,
            curr_spends_tv: 0,
            curr_spends_radio: 0,
            curr_spends_billboard: 0,
            curr_spends_print: 0,
            curr_spends_digital: 0,
            sliderSelectedValue: 2 * parseInt(sessionStorage.getItem('no_of_agents') ? sessionStorage.getItem('no_of_agents') : 5000),
            category_selected: 'tv',
            loading: true,
            tv_slots: [],
            tv_days: [],
            tv_frequency: 0,
            radio_slots: [],
            radio_days: [],
            radio_frequency: 0,
            billboard_slots: [],
            billboard_days: [],
            billboard_frequency: 0,
            print_slots: [],
            print_days: [],
            print_frequency: 0,
            digital_slots: [],
            digital_days: [],
            digital_frequency: 0,
            tv_price: 0,
            radio_price: 0,
            billboard_price: 0,
            print_price: 0,
            digital_price: 0,
            estimatedPrice: 0,
            slots_checkboxes: category['tv']['slots'].reduce(
                (options, option) => ({
                    ...options,
                    [option]: false
                }),
                {}
            ),
            days_checkboxes: category['tv']['days'].reduce(
                (options, option) => ({
                    ...options,
                    [option]: false
                }),
                {}
            ),
            frequency_radio: Object.keys(category['tv']['frequency']).reduce(
                (option) => ({
                    [option]: false
                }),
                {}
            ),
            prev_pricing: 0,
            pricing: 0,
            retail_cost: 1,
            manufacture_cost: 0.35,
            value: 1,
            compData: [],
            priceData: []
        };
    }

    // Promotion widget Functions

    changeProps(el, type) { // Function to change the promotion channel
        this.promoSave();
        this.deselectAll();
        this.deselectAllRadios();
        const self = this;

        setTimeout(() => {
            this.state[`${el}_slots`].forEach(d => {
                let t = document.getElementById(`${d}_slots`);
                if (t) {
                    t.click();
                }

            });
            this.state[`${el}_days`].forEach(d => {
                let t = document.getElementById(`${d}_days`);
                if (t) {
                    t.click();
                }

            });

            Object.keys(this.state[`${el}_frequency`]).forEach(d => {
                let t = document.getElementById(`${self.state[`${el}_frequency`][d]}_frequency`);
                if (t) {
                    t.click();
                }
            })
        }, 1);

        const types = ["tv", "radio", "billboard", "print", "digital"];
        this.refs[`${el}_div`].style.background = 'whitesmoke';
        this.refs[`${el}_div`].style['border'] = '1px solid #344955';
        this.refs[`${el}_div`].style['border-bottom'] = '1px solid whitesmoke';

        types.filter(function (ele) {
            return ele !== el;
        }).forEach(elem => {
            this.refs[`${elem}_div`].style.background = 'rgba(0,0,0,0)';
            this.refs[`${elem}_div`].style['border'] = '1px solid rgba(0,0,0,0)';
            this.refs[`${elem}_div`].style['border-bottom'] = '1px solid #344955';
        })
        this.setState({
            category_selected: el
        })
    };

    selectAllCheckboxes = isSelected => { // Save state of checkbox
        Object.keys(this.state.slots_checkboxes).forEach(checkbox => {
            this.setState(prevState => ({
                slots_checkboxes: {
                    ...prevState.slots_checkboxes,
                    [checkbox]: isSelected
                }
            }));
        });
        Object.keys(this.state.days_checkboxes).forEach(checkbox => {
            this.setState(prevState => ({
                days_checkboxes: {
                    ...prevState.days_checkboxes,
                    [checkbox]: isSelected
                }
            }));
        });
    };

    selectAllRadios = isSelected => {
        Object.keys(this.state.frequency_radio).forEach(radio => {
            this.setState(prevState => ({
                frequency_radio: {
                    ...prevState.frequency_radio,
                    [radio]: isSelected
                }
            }));
        });
    };

    selectAll = () => this.selectAllCheckboxes(true); // Select all checkboxes

    deselectAll = () => this.selectAllCheckboxes(false); // Deselect all Checkboxes

    deselectAllRadios = () => this.selectAllRadios(false);

    handleCheckboxChange(type, changeEvent) { // Handle Checkbox change event
        const { name } = changeEvent.target;

        this.setState(prevState => ({
            [`${type}_checkboxes`]: {
                ...prevState[`${type}_checkboxes`],
                [name]: !prevState[`${type}_checkboxes`][name]
            }
        }));
    };

    createCheckbox(type, option) { // Function to create a checkbox
        return <Checkbox
            label={option}
            isSelected={this.state[`${type}_checkboxes`][option]}
            onCheckboxChange={this.handleCheckboxChange.bind(this, type)}
            type={`${type}`}
            key={option}
            ref={option}
            productClass="product-form2"
        />
    };

    createCheckboxes = (el, type) => category[this.state.category_selected][type].map(this.createCheckbox.bind(this, type)); // Create checkboxes for each Slot, Channel and Frequency

    handleRadioChange(type, changeEvent) {
        const { name } = changeEvent.target;
        this.setState(prevState => ({
            [`${type}_radio`]: {
                [name]: !prevState[`${type}_radio`][name]
            }
        }));
    };

    createRadio(type, option) {
        return <Checkbox
            label={option}
            isSelected={this.state[`${type}_radio`][option]}
            onCheckboxChange={this.handleRadioChange.bind(this, type)}
            type={`${type}`}
            key={option}
            ref={option}
        />
    };

    createRadios = (el, type) => Object.keys(category[this.state.category_selected][type]).map(this.createRadio.bind(this, type));

    promoReset = () => {

        this.deselectAll();
        this.deselectAllRadios();
        this.promoSave();
        this.setState({ sliderSelectedValue: 2 * parseInt(sessionStorage.getItem('no_of_agents') ? sessionStorage.getItem('no_of_agents') : 5000) })
    };

    promoSave() {
        this.setState({

            [`${this.state.category_selected}_slots`]: Object.keys(this.state.slots_checkboxes).filter(d => {
                return this.state.slots_checkboxes[d]
            }),
            [`${this.state.category_selected}_days`]: Object.keys(this.state.days_checkboxes).filter(d => {
                return this.state.days_checkboxes[d]
            }),
            [`${this.state.category_selected}_frequency`]: Object.keys(this.state.frequency_radio).filter(d => {
                return this.state.frequency_radio[d]
            }),
            [`${this.state.category_selected}_price`]: this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                return this.state.slots_checkboxes[d]
            }), Object.keys(this.state.days_checkboxes).filter(d => {
                return this.state.days_checkboxes[d]
            }), Object.keys(this.state.frequency_radio).filter(d => {
                return this.state.frequency_radio[d]
            }), (sessionStorage.getItem('no_of_agents') ? sessionStorage.getItem('no_of_agents') : 5000))

        });

    };

    channelCost(channel, slots, days, intensity, no_of_agents) {

        let chn_cost = prices.filter(d => {
            return d.Media === channel
        })[0];

        let flag = 0;

        let slots_prices = slots.map(d => {
            return chn_cost[d]
        }).reduce((a, b) => a + b, 0)
        let days_prices = days.map(d => {
            return chn_cost[d]
        }).reduce((a, b) => a + b, 0)
        let frequency_prices = isNaN(chn_cost[`X${category[channel]['frequency'][intensity]}`]) ? 0 : chn_cost[`X${category[channel]['frequency'][intensity]}`];

        if ((channel === "tv" || channel === "radio") && slots_prices > 0 && days_prices > 0 && frequency_prices > 0) {
            flag = 1;
        }
        else if (channel === "billboard" && frequency_prices > 0) {
            flag = 1;
        }
        else if (channel === "digital" && slots_prices > 0) {
            flag = 1;
        }
        else if (channel === "print" && days_prices > 0 && frequency_prices > 0) {
            flag = 1;
        }

        if (flag === 1) {

            let price_chn = parseFloat(((chn_cost['Base_Price'] + slots_prices + days_prices + frequency_prices) / (10)).toFixed(2));

            if (channel === "digital") {
                price_chn = parseFloat(price_chn / 52 + (this.state.sliderSelectedValue * 0.007566));
                return isNaN(price_chn) ? 0 : (price_chn);
            }
            return isNaN(price_chn) ? 0 : (price_chn / 52);

        } else {
            return 0
        }

    };

    getSpends() {
        fetch(config.api.url + 'spends/' + config.scenarioId, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            headers: {
                "Authorization": `${config.token}`,
                "Content-Type": "application/json",
            },

        })
            .then(response => {
                return response.json()
            })
            .then(data => {
                // {
                //     "digitalmedia": this.state.digital_price,
                //     "tv":this.state.tv_price,
                //     "radio":this.state.radio_price,
                //     "billboard":this.state.billboard_price,
                //     "printmedia":this.state.print_price
                // }
                this.setState({
                    tv_price: data.tv,
                    radio_price: data.radio,
                    billboard_price: data.billboard,
                    print_price: data.printmedia,
                    digital_price: data.digitalmedia,
                    loading: false
                })

            })
    };

    getSlider = () => {
        const self = this;
        const n = parseInt(sessionStorage.getItem('no_of_agents') ? sessionStorage.getItem('no_of_agents') : 5000)
        const sliderSelectedValue = self.state.sliderSelectedValue;
        return (
            <Grid item style={{ marginTop: "2%" }} >
                <label >{"Impressions : " + sliderSelectedValue}</label>
                <Slider
                    min={n / 2}
                    max={20 * n}
                    step={1}
                    defaultValue={2 * n}
                    value={this.state.sliderSelectedValue}
                    onChange={(newVal) => {
                        self.setState({
                            sliderSelectedValue: newVal
                        });
                    }} />
            </Grid>
        );
    };

    renderDiv(el) {
        if (el === 'tv')
            return <div className="selectionBox">
                <div className="subTitleBox">
                    <div className="slotCheckbox">
                        <div style={{ paddingBottom: '1vh' }}>
                            Slots
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'slots')}
                        </div>
                    </div>
                    <div className="daysCheckbox">
                        <div style={{ paddingBottom: '1vh' }}>
                            Days of week
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'days')}
                        </div>
                    </div>
                    <div className="frequencyRadio">
                        <div style={{ paddingBottom: '1vh' }}>
                            Frequency
                        </div>
                        <div>
                            {this.createRadios(null, 'frequency')}
                        </div>
                    </div>
                </div>
                <div className="spendDetailBox">
                    <div className="dollarSpends" style={{ padding: '0 0.5vw' }}>
                        <div>
                            Current Spends:
                            ${abbreviateNumber(this.state.curr_spends_tv)}/wk
                        </div>

                        <div>
                            Estimated Spends:
                            ${abbreviateNumber(this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                                return this.state.slots_checkboxes[d]
                            }), Object.keys(this.state.days_checkboxes).filter(d => {
                                return this.state.days_checkboxes[d]
                            }), Object.keys(this.state.frequency_radio).filter(d => {
                                return this.state.frequency_radio[d]
                            })))}/wk
                        </div>
                    </div>
                    <div className="promo_resetButton" ref="promo_reset" onClick={this.promoReset.bind(this)}> Reset  </div>
                </div>
            </div>

        else if (el === 'radio')
            return <div className="selectionBox">
                <div className="subTitleBox">
                    <div className="slotCheckbox">
                        <div style={{ paddingBottom: '1vh' }}>
                            Slots
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'slots')}
                        </div>
                    </div>
                    <div className="daysCheckbox">
                        <div style={{ paddingBottom: '1vh' }}>
                            Days of week
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'days')}
                        </div>
                    </div>
                    <div className="frequencyRadio">
                        <div style={{ paddingBottom: '1vh' }}>
                            Frequency
                        </div>
                        <div>
                            {this.createRadios(null, 'frequency')}
                        </div>
                    </div>
                </div>
                <div className="spendDetailBox">
                    <div className="dollarSpends" style={{ padding: '0 0.5vw' }}>
                        <div>
                            Current Spends:
                            ${abbreviateNumber(this.state.curr_spends_radio)}/wk
                        </div>

                        <div>
                            Estimated Spends:
                            ${abbreviateNumber(this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                                return this.state.slots_checkboxes[d]
                            }), Object.keys(this.state.days_checkboxes).filter(d => {
                                return this.state.days_checkboxes[d]
                            }), Object.keys(this.state.frequency_radio).filter(d => {
                                return this.state.frequency_radio[d]
                            })))}/wk
                        </div>
                    </div>
                    <div className="promo_resetButton" ref="promo_reset" onClick={this.promoReset.bind(this)}> Reset
                    </div>
                </div>
            </div>

        else if (el === 'billboard')
            return <div className="selectionBox">
                <div className="subTitleBox">
                    <div className="frequencyRadio">
                        <div style={{ paddingBottom: '1vh' }}>
                            Intensity
                        </div>
                        <div>
                            {this.createRadios(null, 'frequency')}
                        </div>
                    </div>
                </div>
                <div className="spendDetailBox">
                    <div className="dollarSpends" style={{ padding: '0 0.5vw' }}>
                        <div>
                            Current Spends:
                            ${abbreviateNumber(this.state.curr_spends_billboard)}/wk
                        </div>

                        <div>
                            Estimated Spends:
                            ${abbreviateNumber(this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                                return this.state.slots_checkboxes[d]
                            }), Object.keys(this.state.days_checkboxes).filter(d => {
                                return this.state.days_checkboxes[d]
                            }), Object.keys(this.state.frequency_radio).filter(d => {
                                return this.state.frequency_radio[d]
                            })))}/wk
                        </div>
                    </div>
                    <div className="promo_resetButton" ref="promo_reset" onClick={this.promoReset.bind(this)}> Reset
                    </div>
                </div>
            </div>

        else if (el === 'print')
            return <div className="selectionBox">
                <div className="subTitleBox">
                    <div className="frequencyRadio">
                        <div style={{ paddingBottom: '1vh' }}>
                            Intensity
                        </div>
                        <div>
                            {this.createRadios(null, 'frequency')}
                        </div>
                    </div>
                    <div className="daysCheckbox">
                        <div style={{ paddingBottom: '1vh' }}>
                            Days of week
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'days')}
                        </div>
                    </div>
                </div>
                <div className="spendDetailBox">
                    <div className="dollarSpends" style={{ padding: '0 0.5vw' }}>
                        <div>
                            Current Spends:
                            ${abbreviateNumber(this.state.curr_spends_print)}/wk
                        </div>

                        <div>
                            Estimated Spends:
                            ${abbreviateNumber(this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                                return this.state.slots_checkboxes[d]
                            }), Object.keys(this.state.days_checkboxes).filter(d => {
                                return this.state.days_checkboxes[d]
                            }), Object.keys(this.state.frequency_radio).filter(d => {
                                return this.state.frequency_radio[d]
                            })))}/wk
                        </div>
                    </div>
                    <div className="promo_resetButton" ref="promo_reset" onClick={this.promoReset.bind(this)}> Reset
                    </div>
                </div>
            </div>

        else if (el === 'digital')
            return <div className="selectionBox">
                <div className="subTitleBox">
                    <div className="frequencyRadio">
                        <div style={{ paddingBottom: '1vh' }}>
                            Channels
                        </div>
                        <div>
                            {this.createCheckboxes(null, 'slots')}
                            {this.getSlider()}
                        </div>
                    </div>
                </div>
                <div className="spendDetailBox">
                    <div className="dollarSpends" style={{ padding: '0 0.5vw' }}>
                        <div>
                            Current Spends:
                            ${abbreviateNumber(this.state.curr_spends_digital)}/wk
                        </div>

                        <div>
                            Estimated Spends:
                            ${abbreviateNumber(this.channelCost(this.state.category_selected, Object.keys(this.state.slots_checkboxes).filter(d => {
                                return this.state.slots_checkboxes[d]
                            }), Object.keys(this.state.days_checkboxes).filter(d => {
                                return this.state.days_checkboxes[d]
                            }), Object.keys(this.state.frequency_radio).filter(d => {
                                return this.state.frequency_radio[d]
                            })))}/wk
                        </div>
                    </div>
                    <div className="promo_resetButton" ref="promo_reset" onClick={this.promoReset.bind(this)}> Reset
                    </div>
                </div>
            </div>

    };

    getTotalSpends() {
        let MaxSpends = Math.ceil((sessionStorage.getItem('no_of_agents') ? sessionStorage.getItem('no_of_agents') : 5000) * 0.021858482 * 1.25);
        let totalSpends = this.state.tv_price + this.state.radio_price + this.state.billboard_price + this.state.print_price + this.state.digital_price;
        if (totalSpends > MaxSpends) {
            if (this.refs.promo_submit) {
                this.refs.promo_submit.style.background = "grey"
                this.refs.promo_submit.style.pointerEvents = 'none'
            }
            this.props.showNotification("Spends are exceeding budget!", { variant: "warning" });
            return 0
        } else {
            if (this.refs.promo_submit) {
                this.refs.promo_submit.style.background = "#1e73e8";
                this.refs.promo_submit.style.pointerEvents = 'auto'

            }
            return totalSpends.toFixed(2)
        }

    };

    getPromotion() {

        fetch(config.api.url + 'promotion/' + config.scenarioId, { //
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            headers: {
                "Authorization": `${config.token}`,
                "Content-Type": "application/json",
            },

        })
            .then(response => {
                return response.json()
            })
            .then(data => {
                setTimeout(() => {
                    data.filter(d => {
                        return d.channel === 'tv'
                    })[0].slots.forEach(d => {
                        let t = document.getElementById(`${d}_slots`);
                        if (t) {
                            t.click();
                        }

                    });
                    data.filter(d => {
                        return d.channel === 'tv'
                    })[0].days.forEach(d => {
                        let t = document.getElementById(`${d}_days`);
                        if (t) {
                            t.click();
                        }

                    });

                    Object.keys([swapJsonKeyValues(category['tv']['frequency'])[data.filter(d => {
                        return d.channel === 'tv'
                    })[0].intensity]]).forEach(d => {
                        let t = document.getElementById(`${[swapJsonKeyValues(category['tv']['frequency'])[data.filter(d => {
                            return d.channel === 'tv'
                        })[0].intensity]][d]}_frequency`);
                        if (t) {

                            t.click();
                        }
                    })
                }, 1);
                this.setState({
                    tv_slots: data.filter(d => {
                        return d.channel === 'tv'
                    })[0].slots,
                    tv_days: data.filter(d => {
                        return d.channel === 'tv'
                    })[0].days,
                    tv_frequency: [swapJsonKeyValues(category['tv']['frequency'])[data.filter(d => {
                        return d.channel === 'tv'
                    })[0].intensity]],

                    radio_slots: data.filter(d => {
                        return d.channel === 'radio'
                    })[0].slots,
                    radio_days: data.filter(d => {
                        return d.channel === 'radio'
                    })[0].days,
                    radio_frequency: [swapJsonKeyValues(category['radio']['frequency'])[data.filter(d => {
                        return d.channel === 'radio'
                    })[0].intensity]],

                    billboard_slots: data.filter(d => {
                        return d.channel === 'billboard'
                    })[0].slots,
                    billboard_days: data.filter(d => {
                        return d.channel === 'billboard'
                    })[0].days,
                    billboard_frequency: [swapJsonKeyValues(category['billboard']['frequency'])[data.filter(d => {
                        return d.channel === 'billboard'
                    })[0].intensity]],

                    print_slots: data.filter(d => {
                        return d.channel === 'printmedia'
                    })[0].slots,
                    print_days: data.filter(d => {
                        return d.channel === 'printmedia'
                    })[0].days,
                    print_frequency: [swapJsonKeyValues(category['print']['frequency'])[data.filter(d => {
                        return d.channel === 'printmedia'
                    })[0].intensity]],

                    digital_slots: data.filter(d => {
                        return d.channel === 'digitalmedia'
                    })[0].slots,
                    digital_days: data.filter(d => {
                        return d.channel === 'digitalmedia'
                    })[0].days,
                    digital_frequency: [swapJsonKeyValues(category['digital']['frequency'])[data.filter(d => {
                        return d.channel === 'digitalmedia'
                    })[0].intensity]],

                    loading: false
                })

                this.getSpends();


            })


    };

    setCurrentSpends() {
        this.setState({
            curr_spends_tv: this.state.tv_price,
            curr_spends_radio: this.state.radio_price,
            curr_spends_billboard: this.state.billboard_price,
            curr_spends_print: this.state.print_price,
            curr_spends_digital: this.state.digital_price
        })
    }

    postPromotion = async () => {
        await this.promoSave();
        //this.props.showNotification("Updating Promotion");

        this.setCurrentSpends();

        fetch(config.api.url + 'promotion', {
            method: 'POST',
            headers: {
                'Authorization': `${config.token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },

            body: JSON.stringify({
                "scenarioId": config.scenarioId,
                "promotions": [
                    {
                        "channel": "tv",
                        "slots": this.state.tv_slots.length > 0 ? this.state.tv_slots : ['None'],
                        "days": this.state.tv_days.length > 0 ? this.state.tv_days : ['None'],
                        "intensity": category['tv']['frequency'][this.state.tv_frequency[0]] ? category['tv']['frequency'][this.state.tv_frequency[0]] : 0,
                        "impressions": 0
                    },
                    {
                        "channel": "radio",
                        "slots": this.state.radio_slots.length > 0 ? this.state.radio_slots : ['None'],
                        "days": this.state.radio_days.length > 0 ? this.state.radio_days : ['None'],
                        "intensity": category['radio']['frequency'][this.state.radio_frequency[0]] ? category['radio']['frequency'][this.state.radio_frequency[0]] : 0,
                        "impressions": 0
                    },
                    {
                        "channel": "printmedia",
                        "slots": this.state.print_slots.length > 0 ? this.state.print_slots : ['None'],
                        "days": this.state.print_days.length > 0 ? this.state.print_days : ['None'],
                        "intensity": category['print']['frequency'][this.state.print_frequency[0]] ? category['print']['frequency'][this.state.print_frequency[0]] : 0,
                        "impressions": 0
                    },
                    {
                        "channel": "billboard",
                        "slots": this.state.billboard_slots.length > 0 ? this.state.billboard_slots : ['None'],
                        "days": this.state.billboard_days.length > 0 ? this.state.billboard_days : ['None'],
                        "intensity": category['billboard']['frequency'][this.state.billboard_frequency[0]] ? category['billboard']['frequency'][this.state.billboard_frequency[0]] : 0,
                        "impressions": 0
                    },
                    {
                        "channel": "digitalmedia",
                        "slots": this.state.digital_slots.length > 0 ? this.state.digital_slots : ['None'],
                        "days": ['None'],
                        "intensity": this.state.digital_slots.length > 0 ? this.state.digital_slots.length : 0,
                        "impressions": this.state.sliderSelectedValue
                    }
                ],
                "promotion_spends": {
                    "digitalmedia": this.state.digital_price,
                    "tv": this.state.tv_price,
                    "radio": this.state.radio_price,
                    "billboard": this.state.billboard_price,
                    "printmedia": this.state.print_price
                }
            })

        }, { mode: 'cors' })

            .then(response => {

                return response.json();

            }).then(response => {

                if (response.message === "Simulation Ended") {
                    this.props.showNotification("Promotion could not be updated!", { variant: "info" });
                    this.setState({
                        simCompleted: true
                    })
                }
                else {
                    this.props.showNotification("Promotion updated!", { variant: "success" });
                    GlobalEvents.trigger('PromotionUpdated');
                    sessionStorage.setItem('PromotionUpdated', 'true')
                }

            }).catch(err => {
                console.error(err);
                this.props.showNotification("Promotion could not be updated", { variant: "error" });
            });
    };

    // Pricing widget Functions

    postPrice() { // Send the price to the orchestrator

        let prod = JSON.parse(sessionStorage.getItem("productData"))
        let manf_cost = parseFloat(prod.manufacturing_cost.replace("$", ""))

        if (sessionStorage.getItem('priceUpdated') !== 'true') {
            fetch(config.api.url + 'pricing', {
                method: 'POST',
                headers: {
                    'Authorization': `${config.token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify({
                    "scenarioId": config.scenarioId,
                    "cost_to_customer": `$${((parseFloat(1) + parseFloat(manf_cost)) + Math.ceil((parseFloat(1) + parseFloat(manf_cost)) * 0.3)).toFixed(2)}`,
                    "manufacturing_cost": `$${manf_cost}`,
                    "profit_margin": `${Math.ceil((1) * 100 / (manf_cost))}`
                })

            }, { mode: 'cors' })

                .then(response => {

                    return response.json();

                }).then(response => {
                    this.getCompData();
                    GlobalEvents.trigger('pricing_updated')
                }).catch(err => {
                    console.error(err);
                });
        }


    }

    getCompData() {
        // Function to get Competitor data
        fetch(config.api.url + "competitor/" + config.scenarioId, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            headers: {
                Authorization: `${config.token}`,
                "Content-Type": "application/json"
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {

                for (let i = 0; i < data["Product_attributes"].length; i++) {
                    let temp = data.Product_attributes[i].brand;
                    if (temp === 0) {
                        data.Product_attributes[i].brand = "YourBrand"
                    }
                    else {
                        data.Product_attributes[i].brand = "Competitor_" + i;
                    }
                }

                let temp_health = { name: "Health" };
                let temp_taste = { name: "Taste" };
                let temp_pleasure = { name: "Pleasure" };
                for (let i = 0; i < data["Product_attributes"].length; i++) {
                    temp_health[
                        data["Product_attributes"][i]["brand"]
                    ] = convertRange(
                        data["Product_attributes"][i]["health"],
                        [-4, 11], // On a scale of 0 to 11
                        [0, 11]
                    ).toFixed(2);
                    temp_taste[data["Product_attributes"][i]["brand"]] = convertRange(
                        data["Product_attributes"][i]["taste"],
                        [-4, 11], // On a scale of 0 to 11
                        [0, 11]
                    ).toFixed(2);
                    temp_pleasure[
                        data["Product_attributes"][i]["brand"]
                    ] = convertRange(
                        data["Product_attributes"][i]["pleasure"],
                        [-4, 11], // On a scale of 0 to 11
                        [0, 11]
                    ).toFixed(2);
                }
                let temp_price = [];
                if (data.Product_attributes && data.Product_attributes.length > 0) {
                    data.Product_attributes.forEach(o => {
                        temp_price.push({
                            y: o.price,
                            name: o.brand
                        });
                    });
                }

                this.setState({
                    compData: [temp_health, temp_pleasure, temp_taste],
                    priceData: temp_price
                });
            });
    }

    incrementValue() {
        // Increment the pricing
        let pricing = this.state.pricing;
        pricing++;
        this.setState({
            pricing: pricing
        });
    }

    decrementValue() {
        // Decrement the pricing
        let pricing = this.state.pricing;
        pricing--;
        const manufacture_cost = parseFloat(this.state.manufacture_cost);
        const leastValue = manufacture_cost + Math.ceil((manufacture_cost) * 0.3)

        if (leastValue <= pricing) {
            this.setState({
                pricing: pricing
            });
        }
        else {
            this.props.showNotification("Pricing cannot be further reduced", { variant: "error" });
        }
    }

    submitPrice() {
        // Submit price to the orchestrator
        const self = this;
        fetch(
            config.api.url + "pricing",
            {
                method: "POST",
                headers: {
                    Authorization: `${config.token}`,
                    Accept: "application/json",

                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    "scenarioId": config.scenarioId,
                    cost_to_customer: `$${(parseFloat(this.state.pricing)).toFixed(2)}`,
                    manufacturing_cost: `$${this.state.manufacture_cost}`,
                    profit_margin: `${Math.round(((this.state.pricing - this.state.manufacture_cost) * 100) / this.state.manufacture_cost
                    )}`
                })
            },
            { mode: "cors" }
        )
            .then(response => {
                return response.json();
            })
            .then(response => {


                if (response.message === "Simulation Ended") {
                    this.props.showNotification("Pricing could not be updated!", { variant: "info" });
                    this.setState({
                        simCompleted: true
                    })
                }
                else {
                    sessionStorage.setItem("priceUpdated", "true");
                    self.props.showNotification("Price Updated", { variant: "success" });
                    const tempPricing = self.state.pricing
                    self.setState({ prev_pricing: tempPricing })
                    sessionStorage.setItem(
                        "priceData",
                        JSON.stringify({
                            profit_value: this.state.retail_cost
                        })
                    );
                    this.getCompData();
                    GlobalEvents.trigger("pricing_updated");
                }

            })
            .catch(err => {
                console.error(err);
                self.props.showNotification("Price could not updated", { variant: "error" });
            });
    }

    getManfCost = () => {
        // Get the manufacturing cost
        let manf_cost = JSON.parse(sessionStorage.getItem('productData'))
        manf_cost = parseFloat((manf_cost.manufacturing_cost.replace("$", "")))
        let pricing = ((parseFloat(1) + parseFloat(manf_cost)) + Math.ceil((parseFloat(1) + parseFloat(manf_cost)) * 0.3))

        this.setState({
            manufacture_cost: manf_cost,
            pricing: pricing,
            prev_pricing: pricing
        })
    }


    //Common funtions

    componentDidMount() {
        if (sessionStorage.getItem('PromotionUpdated') === 'true' || sessionStorage.getItem('priceUpdated') === 'true') {
            this.getPromotion()

        } else {
            if (sessionStorage.getItem('simStarted') !== 'true') {
            } else {
                this.setState({
                    loading: false
                })
            }
        }

        GlobalEvents.on("price_rerender", this.getManfCost.bind(this));
        this.getManfCost();
        this.postPrice()
        this.getCompData();

        if (sessionStorage.getItem("simCompleted") === "true") {
            // If simulation is completed
            if (this.refs.submit) {
                this.refs["submit"].style.background = "#c1c1c1";
                this.refs["submit"].style.pointerEvents = "none";
                this.refs["PricingWidget"].style.pointerEvents = "none";
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (sessionStorage.getItem("simCompleted") === "true" || this.state.simCompleted) {
            if (this.refs.submit) {
                this.refs["submit"].style.background = "#c1c1c1";
                this.refs["submit"].style.pointerEvents = "none";
                this.refs["PricingWidget"].style.pointerEvents = "none";
            }
        }
    }

    onSubmit = async () => {
        await this.promoSave();

        // Defining flags to notify user when minimum promotion options are not fully selected
        let flag = 0;
        let finalFlag = 0;

        // Resetting checkboxes if all 3 - days, slots and frequency is not selected and unchecking the checkboxes
        const A = this.state.tv_slots.length
        const B = this.state.tv_days.length
        let C = this.state.tv_frequency.length
        const D = this.state.radio_slots.length
        const E = this.state.radio_days.length
        let F = this.state.radio_frequency.length
        const G = this.state.print_days.length
        let H = this.state.print_frequency.length
        let incorrArr = []


        if (C === undefined) { C = 0 }
        if (F === undefined) { F = 0 }
        if (H === undefined) { H = 0 }

        // eslint-disable-next-line
        if (!(A > 0 && B > 0 && C > 0) && !(A == 0 && B == 0 && C == 0)) {
            incorrArr.push("TV")
        }

        // eslint-disable-next-line
        if (!(D > 0 && E > 0 && F > 0) && !(D == 0 && E == 0 && F == 0)) {
            incorrArr.push("Radio")
        }

        // eslint-disable-next-line
        if (!(G > 0 && H > 0) && !(G == 0 && H == 0)) {
            incorrArr.push("Print")
        }

        if (incorrArr.length > 0) { this.props.showNotification("Incorrect promotion selected for " + incorrArr, { variant: "error" }); }

        // eslint-disable-next-line
        if (this.state.tv_slots.length == 0 || this.state.tv_days.length == 0 || this.state.tv_frequency == 0) {
            flag++;
            this.setState({
                tv_slots: [],
                tv_days: [],
                tv_frequency: 0

            })
            if (this.state.category_selected === 'tv') {
                this.promoReset()
            }

        }

        // eslint-disable-next-line
        if (this.state.radio_slots.length == 0 || this.state.radio_days.length == 0 || this.state.radio_frequency == 0) {
            this.setState({
                radio_slots: [],
                radio_days: [],
                radio_frequency: 0,
            })
            flag++;
            if (this.state.category_selected === 'radio') {
                this.promoReset()
            }

        }

        // eslint-disable-next-line
        if (this.state.print_days.length == 0 || this.state.print_frequency == 0) {
            this.setState({
                print_days: [],
                print_frequency: 0,
            })
            flag++;
            if (this.state.category_selected === 'print') {
                this.promoReset()
            }

        }

        // eslint-disable-next-line
        if (this.state.billboard_frequency == 0) {
            flag++;
        }

        // eslint-disable-next-line
        if (this.state.digital_slots.length == 0 || this.state.digital_slots[0] === 'None') {
            flag++;
        }

        const curr_spends = this.state.curr_spends_tv + this.state.curr_spends_radio + this.state.curr_spends_billboard + this.state.curr_spends_print + this.state.curr_spends_digital;
        const est_spends = this.state.tv_price + this.state.radio_price + this.state.billboard_price + this.state.print_price + this.state.digital_price;

        //Notifying user when promotions are not selected

        // eslint-disable-next-line
        if (!(curr_spends == est_spends)) {
            this.postPromotion();
        }
        else if (flag === 5) {
            this.props.showNotification("No Promotions were selected !", { variant: "warning" });
            finalFlag++;
        }
        else {
            finalFlag++;
        }

        if (!(this.state.pricing === this.state.prev_pricing)) {
            this.submitPrice();
        }
        else {
            finalFlag++;
        }

        if (finalFlag === 2) {
            this.props.showNotification("Nothing to Submit!", { variant: "warning" });
        }
    }
    render() {
        if (this.state.compData.length > 0) {
            return (
                <div
                    className='container_price'
                    id='container_price'
                    ref='PricingWidget'
                >
                    <div className="PromotionWidget" id="PromotionWidget" ref="PromotionWidget">
                        <div style={{ fontWeight: "bold" }}>
                            Configure Promotions
                        </div>
                        <div style={{
                            "width": "93",
                            'margin': '0 3.5%',
                        }}>
                            <div className="promo_card">
                                <div className="promo_card_element" ref="tv_div" title={"Television Ads"}
                                    onClick={this.changeProps.bind(this, "tv")}
                                    style={{
                                        "float": "left",
                                        'background': 'whitesmoke',
                                        border: '1px solid #344955',
                                        borderBottom: '1px solid whitesmoke'
                                    }}>
                                    <img src="./PromoWidget/television.svg" alt="Avatar" style={{ "width": "1.5vw" }}></img>
                                    <div className="promo_text_container">
                                        <div>
                                            TV Ads
                                        </div>
                                    </div>
                                </div>
                                <div className="promo_card_element" ref="radio_div" title={"Radio Ads"}
                                    onClick={this.changeProps.bind(this, "radio")}
                                    style={{ "float": "left", borderBottom: '1px solid #344955' }}>
                                    <img src="./PromoWidget/radio.svg" alt="Avatar" style={{ "width": "1.5vw" }}></img>
                                    <div className="promo_text_container">
                                        <div>
                                            Radio
                                        </div>
                                    </div>
                                </div>
                                <div className="promo_card_element" ref="billboard_div" title={"Billboard"}
                                    onClick={this.changeProps.bind(this, "billboard")}
                                    style={{ float: "left", borderBottom: '1px solid #344955' }}>
                                    <img src="./PromoWidget/billboard.svg" alt="Avatar" style={{ "width": "1.5vw" }}></img>
                                    <div className="promo_text_container">
                                        <div>
                                            Billboard
                                        </div>
                                    </div>
                                </div>
                                <div className="promo_card_element" ref="print_div" title={"Print Media"}
                                    onClick={this.changeProps.bind(this, "print")}
                                    style={{ float: "left", borderBottom: '1px solid #344955' }}>
                                    <img src="./PromoWidget/print_media.svg" alt="Avatar" style={{ "width": "1.5vw" }}></img>
                                    <div className="promo_text_container">
                                        <div>
                                            Print Media
                                        </div>
                                    </div>
                                </div>
                                <div className="promo_card_element" ref="digital_div" title={"Digital Media"}
                                    onClick={this.changeProps.bind(this, "digital")}
                                    style={{ float: "left", borderBottom: '1px solid #344955' }}>
                                    <img src="./PromoWidget/digital-marketing.svg" alt="Avatar" style={{ "width": "1.5vw" }}></img>
                                    <div className="promo_text_container">
                                        <div>
                                            Digital Media
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {this.renderDiv(this.state.category_selected)}

                    </div>

                    <div id='competitorDetails' className='competitorValues'>
                        <div className='compTitle'>Competitor Prices and Attributes</div>
                        <div className='compCharts'>
                            <div className='compBarChart'>
                                <HorizontalBarChart
                                    data={this.state.priceData.length > 0 ? this.state.priceData : []}
                                    color="#e8eef1"
                                    colors={chartColor}
                                    yTitle={"Price"}
                                    // eslint-disable-next-line
                                    label={"${y}"}
                                    tooltip={true}
                                    title={null}
                                    showProductInfo={true}
                                    // key={`${new Date()}`}
                                />
                            </div>
                            <div className='compSpiderChart'>
                                <SpiderChart
                                    compData={this.state.compData}
                                    colors={chartColor}
                                />
                            </div>
                        </div>
                        <div className='summary'>
                            <div className='quantity buttons_added'>
                                <div style={{ fontSize: '0.8vw' }}>
                                    Pricing ($) <br></br>
                                    <span style={{ fontSize: '0.6vw' }}>Mfg. Price ( ${this.state.manufacture_cost.toFixed(2)} )</span>
                                </div>
                                <input
                                    type='button'
                                    onClick={this.decrementValue.bind(this)}
                                    value='-'
                                    className='minus'
                                />
                                <input
                                    key={`${this.state.pricing}`}
                                    type='number'
                                    id='priceNumberStepper'
                                    defaultValue={this.state.pricing.toFixed(2)}
                                    title='value'
                                    className='input-text qty text'
                                />
                                <input
                                    type='button'
                                    onClick={this.incrementValue.bind(this)}
                                    value='+'
                                    className='plus'
                                />
                            </div>
                            <input
                                type='button'
                                id='submitPrice'
                                className='submitPrice'
                                value='Submit'
                                ref='submit'
                                onClick={this.onSubmit.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className='graphLoader'>
                    <div id={"loaderContainerPolicy"}>
                        <div class="lds-facebook-policy"><div></div><div></div><div></div></div>
                    </div>
                </div>
            );
        }
    }
}

export default PolicyLever;
